import { createBrowserHistory } from 'history'
import cfg from '../config'

const history = createBrowserHistory({
  basename: cfg.REACT_APP_PREFIX,
})

export default history
